import type { QuestionType } from '@healthblocks-io/core'

const ARRAY_TYPES: Readonly<Set<QuestionType>> = new Set(['Array', 'MultiSelect', 'MultiSelectComment'])
const TEXT_TYPES: Readonly<Set<QuestionType>> = new Set([
  'Text',
  'LongText',
  'BirthDate',
  'Date',
  'Time',
  'QuickReplies',
])

const STRUCTURED_OBSERVATION_TYPES: Readonly<Set<QuestionType>> = new Set(['Medication', 'Allergy'])

// Types that own their own submit/advance flow (no outer action button)
const SELF_ADVANCING_TYPES: Readonly<Set<QuestionType>> = new Set(['Array', 'File', 'Medication', 'Allergy'])

export { ARRAY_TYPES, SELF_ADVANCING_TYPES, STRUCTURED_OBSERVATION_TYPES, TEXT_TYPES }
